// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"d35c","logoImage":"_4d74"};